module.exports = __webpack_public_path__ + "static/media/comment-times.50fa93cb.svg";